import { render, staticRenderFns } from "./ReceivingReportTypeTabs.vue?vue&type=template&id=7a4821f0&"
import script from "./ReceivingReportTypeTabs.vue?vue&type=script&lang=js&"
export * from "./ReceivingReportTypeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports